module.exports = __webpack_public_path__ + "img/ma211.c0070cab.png";